"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var apiSociete = _interopRequireWildcard(require("@/api/societe"));

var apiGestMens = _interopRequireWildcard(require("@/api/gestmens"));

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'ConfigGestionMensuelle',
  data: function data() {
    return {
      current_gestmens: null,
      periodeRef_gestmens: null,
      isProcessing: false,
      processingStartTime: null,
      processingElapsedTime: '0s',
      refresh: 0,
      pollingInterval: null,
      pollingIntervalSeconds: 10,
      elapsedTimeInterval: null,
      formData: {
        day: 5,
        actif: 0,
        last_periode: '',
        last_executed: '',
        last_status: ''
      }
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  computed: {
    idSociete: function idSociete() {
      return this.$store.getters.user.id_societe;
    },
    lastPeriode: function lastPeriode() {
      // Protection contre "--" ou valeurs invalides
      if (!this.formData.last_periode || this.formData.last_periode === '--') {
        return '--';
      }

      return (0, _moment.default)(this.formData.last_periode, 'YYYYMM').format('MM/YYYY');
    },
    lastExecuted: function lastExecuted() {
      // Protection contre les dates invalides
      if (!this.formData.last_executed) {
        return '--';
      }

      var date = (0, _moment.default)(this.formData.last_executed, 'YYYY-MM-DD HH:mm:ss');

      if (!date.isValid()) {
        return '--';
      }

      return date.format('DD/MM/YYYY à HH:mm:ss');
    },
    elapsedTime: function elapsedTime() {
      // Utilise la propriété calculée en temps réel
      if (!this.processingStartTime) {
        return '0s';
      } // Parser la date de début (format: DD/MM/YYYY à HH:mm:ss)


      var startTime = (0, _moment.default)(this.processingStartTime, 'DD/MM/YYYY à HH:mm:ss');

      if (!startTime.isValid()) {
        return '0s';
      }

      var now = (0, _moment.default)();

      var duration = _moment.default.duration(now.diff(startTime));

      var hours = Math.floor(duration.asHours());
      var minutes = duration.minutes();
      var seconds = duration.seconds();

      if (hours > 0) {
        return "".concat(hours, "h ").concat(minutes, "min ").concat(seconds, "s");
      } else if (minutes > 0) {
        return "".concat(minutes, "min ").concat(seconds, "s");
      } else {
        return "".concat(seconds, "s");
      }
    }
  },
  methods: {
    getData: function () {
      var _getData = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiGestMens.getLastGestMens(this.idSociete).then(function (results) {
                  if (results && results[0] && results[0].periode_gestmens) {
                    _this.current_gestmens = results[0].periode_gestmens;
                  } else {
                    _this.current_gestmens = (0, _moment.default)().format('YYYYMM');
                  } // période de référence affichée dans la zone "Période mensuelle de référence"


                  _this.periodeRef_gestmens = (0, _moment.default)(_this.current_gestmens, 'YYYYMM').subtract(1, 'months').format('YYYYMM');
                }).catch(function (error) {
                  _this.$message(error);
                });

              case 2:
                _context.next = 4;
                return apiSociete.getById(this.idSociete).then(function (results) {
                  if (results && results[0]) {
                    var params = results[0].gestmens_trt_params ? JSON.parse(results[0].gestmens_trt_params) : null;

                    if (params) {
                      _this.formData.day = params.day;
                      _this.formData.actif = params.actif;
                    }

                    var log = results[0].gestmens_trt_log ? JSON.parse(results[0].gestmens_trt_log) : null;

                    if (log) {
                      _this.formData.last_periode = log.last_periode;
                      _this.formData.last_executed = log.last_executed;
                      _this.formData.last_status = log.last_status; // Si un traitement est en cours (status = 2), on récupère l'état et on lance le polling

                      if (log.last_status === '2') {
                        _this.isProcessing = true;
                        _this.processingStartTime = (0, _moment.default)(log.last_executed, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY à HH:mm:ss');

                        _this.startPolling();
                      } else {
                        // Le traitement est terminé
                        _this.isProcessing = false;
                        _this.processingStartTime = null;

                        _this.stopPolling();
                      }
                    }
                  }
                }).catch(function (error) {
                  _this.$message(error);
                });

              case 4:
                this.refresh++;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData() {
        return _getData.apply(this, arguments);
      }

      return getData;
    }(),
    handleSave: function handleSave() {
      var _this2 = this;

      this.$loader(true);
      var data = {
        day: this.formData.day,
        actif: this.formData.actif
      };
      apiSociete.update(this.idSociete, {
        gestmens_trt_params: JSON.stringify(data)
      }).then(function (results) {
        _this2.$message('Mise à jour effectuée avec succès');

        _this2.$loader(false);
      }).catch(function (error) {
        _this2.$message(error);

        _this2.$loader(false);
      });
    },
    handleExecute: function handleExecute() {
      var _this3 = this;

      var newSQLPeriode = (0, _moment.default)(this.periodeRef_gestmens, 'YYYYMM').add(2, 'months').format('YYYYMM');
      var libPeriodeValidation = (0, _moment.default)(this.periodeRef_gestmens, 'YYYYMM').format('MM/YYYY');
      var libPeriodeOuverture = (0, _moment.default)(this.periodeRef_gestmens, 'YYYYMM').add(1, 'months').format('MM/YYYY');
      var prevGestMens = (0, _moment.default)(this.current_gestmens, 'YYYYMM').subtract(1, 'months').format('YYYYMM');

      if (this.periodeRef_gestmens >= this.current_gestmens) {
        this.$alert('La période de référence ne peut pas être supérieure à <strong>' + prevGestMens + '</strong>', 'Erreur', {
          confirmButtonText: 'Fermer',
          type: 'error',
          dangerouslyUseHTMLString: true
        });
      } else {
        var cond = this.periodeRef_gestmens < prevGestMens ? '<br><span style="color:red">Attention une période du <strong>' + libPeriodeOuverture + '</strong> existe déjà !</span>' : '';
        this.$confirm('Voulez-vous valider la période du <strong>' + libPeriodeValidation + '</strong> et ouvrir la nouvelle période de gestion du <strong>' + libPeriodeOuverture + '</strong>' + cond, 'Confirmation: ' + this.$store.getters.user.societe_name, {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }).then(function () {
          _this3.isProcessing = true;
          _this3.processingStartTime = (0, _moment.default)().format('DD/MM/YYYY à HH:mm:ss');
          _this3.processingElapsedTime = '0s'; // Lancer le polling pour suivre l'état du traitement

          _this3.startPolling();

          apiGestMens.newGestMens(_this3.idSociete, newSQLPeriode).then(function () {// Le traitement côté API est fini, mais on vérifie quand même via polling
            // Ne pas arrêter le polling tout de suite, laisser getData() le faire
          }).catch(function (error) {
            _this3.isProcessing = false;
            _this3.processingStartTime = null;

            _this3.stopPolling();

            _this3.$message(error);
          });
        });
      }
    },
    startPolling: function startPolling() {
      var _this4 = this;

      // Arrêter tout polling existant
      this.stopPolling(); // Recalculer immédiatement pour éviter le flash à 0s lors du redémarrage du polling

      if (this.processingStartTime) {
        this.processingElapsedTime = this.getElapsedTime();
      } // Lancer le polling selon la fréquence configurée


      this.pollingInterval = setInterval(function () {
        _this4.getData();
      }, this.pollingIntervalSeconds * 1000); // Lancer un timer pour mettre à jour le temps écoulé toutes les secondes

      this.elapsedTimeInterval = setInterval(function () {
        // Force le re-render en modifiant une variable réactive
        _this4.processingElapsedTime = _this4.getElapsedTime();
      }, 1000);
    },
    stopPolling: function stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }

      if (this.elapsedTimeInterval) {
        clearInterval(this.elapsedTimeInterval);
        this.elapsedTimeInterval = null;
      } // Réinitialiser le temps écoulé


      this.processingElapsedTime = '0s';
    },
    getElapsedTime: function getElapsedTime() {
      /*
      if (!this.processingStartTime) {
        return '0s'
      }
      */
      var startTime = (0, _moment.default)(this.processingStartTime, 'DD/MM/YYYY à HH:mm:ss');

      if (!startTime.isValid()) {
        return '';
      }

      var now = (0, _moment.default)();

      var duration = _moment.default.duration(now.diff(startTime));

      var hours = Math.floor(duration.asHours());
      var minutes = duration.minutes();
      var seconds = duration.seconds();

      if (hours > 0) {
        return "".concat(hours, "h ").concat(minutes, "min ").concat(seconds, "s");
      } else if (minutes > 0) {
        return "".concat(minutes, "min ").concat(seconds, "s");
      } else {
        return "".concat(seconds, "s");
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Arrêter les timers quand le composant est détruit
    this.stopPolling();
  }
};
exports.default = _default;